/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getPassportFile = /* GraphQL */ `query GetPassportFile($id: ID!) {
  getPassportFile(id: $id) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      password
      passport_url
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPassportFileQueryVariables,
  APITypes.GetPassportFileQuery
>;
export const listPassportFiles = /* GraphQL */ `query ListPassportFiles(
  $filter: ModelPassportFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listPassportFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      folder
      title
      url
      passportId
      passport {
        id
        passport_impact
        passport_strategies
        passport_network
        passport_signs
        passport_triggers
        passport_aspects
        mh_issues_current
        mh_issues_past
        mh_challenges
        neuro_details
        neuro_diagnosed
        neuro_challenges
        wb_current
        wb_past
        wb_challenges
        disabilty_details
        disabilty_difficulties
        disabilty_challenges
        profile_gp_details
        profile_support_network
        profile_contacts
        profile_support_services
        profile_work
        profile_dob
        password
        passport_url
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPassportFilesQueryVariables,
  APITypes.ListPassportFilesQuery
>;
export const getPassportFileSec = /* GraphQL */ `query GetPassportFileSec($id: ID!) {
  getPassportFileSec(id: $id) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      profile_university
      password
      passport_url
      createdAt
      updatedAt
      owner
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPassportFileSecQueryVariables,
  APITypes.GetPassportFileSecQuery
>;
export const listPassportFileSecs = /* GraphQL */ `query ListPassportFileSecs(
  $filter: ModelPassportFileSecFilterInput
  $limit: Int
  $nextToken: String
) {
  listPassportFileSecs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      folder
      title
      url
      passportId
      passport {
        id
        passport_impact
        passport_strategies
        passport_network
        passport_signs
        passport_triggers
        passport_aspects
        mh_issues_current
        mh_issues_past
        mh_challenges
        neuro_details
        neuro_diagnosed
        neuro_challenges
        wb_current
        wb_past
        wb_challenges
        disabilty_details
        disabilty_difficulties
        disabilty_challenges
        profile_gp_details
        profile_support_network
        profile_contacts
        profile_support_services
        profile_work
        profile_dob
        profile_university
        password
        passport_url
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPassportFileSecsQueryVariables,
  APITypes.ListPassportFileSecsQuery
>;
export const getPassport = /* GraphQL */ `query GetPassport($id: ID!) {
  getPassport(id: $id) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    password
    passport_url
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPassportQueryVariables,
  APITypes.GetPassportQuery
>;
export const listPassports = /* GraphQL */ `query ListPassports(
  $filter: ModelPassportFilterInput
  $limit: Int
  $nextToken: String
) {
  listPassports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      password
      passport_url
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPassportsQueryVariables,
  APITypes.ListPassportsQuery
>;
export const getPassportSec = /* GraphQL */ `query GetPassportSec($id: ID!) {
  getPassportSec(id: $id) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    profile_university
    password
    passport_url
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPassportSecQueryVariables,
  APITypes.GetPassportSecQuery
>;
export const listPassportSecs = /* GraphQL */ `query ListPassportSecs(
  $filter: ModelPassportSecFilterInput
  $limit: Int
  $nextToken: String
) {
  listPassportSecs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      profile_university
      password
      passport_url
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPassportSecsQueryVariables,
  APITypes.ListPassportSecsQuery
>;
export const getAssistant = /* GraphQL */ `query GetAssistant($id: ID!) {
  getAssistant(id: $id) {
    id
    assistant_report
    assessment
    files_keys
    ocean
    location
    rank
    last_connection
    conditions_accepted
    daily_logs {
      items {
        id
        assistantId
        date
        mood
        tip_shown
        tip
        notes
        diagnostic
        rank
        created_at
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssistantQueryVariables,
  APITypes.GetAssistantQuery
>;
export const listAssistants = /* GraphQL */ `query ListAssistants(
  $filter: ModelAssistantFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssistants(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      assistant_report
      assessment
      files_keys
      ocean
      location
      rank
      last_connection
      conditions_accepted
      daily_logs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssistantsQueryVariables,
  APITypes.ListAssistantsQuery
>;
export const getAssistantDailyLog = /* GraphQL */ `query GetAssistantDailyLog($id: ID!) {
  getAssistantDailyLog(id: $id) {
    id
    assistantId
    assistant {
      id
      assistant_report
      assessment
      files_keys
      ocean
      location
      rank
      last_connection
      conditions_accepted
      daily_logs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    date
    mood
    tip_shown
    tip
    notes
    diagnostic
    rank
    created_at
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssistantDailyLogQueryVariables,
  APITypes.GetAssistantDailyLogQuery
>;
export const listAssistantDailyLogs = /* GraphQL */ `query ListAssistantDailyLogs(
  $filter: ModelAssistantDailyLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listAssistantDailyLogs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      assistantId
      assistant {
        id
        assistant_report
        assessment
        files_keys
        ocean
        location
        rank
        last_connection
        conditions_accepted
        createdAt
        updatedAt
        owner
        __typename
      }
      date
      mood
      tip_shown
      tip
      notes
      diagnostic
      rank
      created_at
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssistantDailyLogsQueryVariables,
  APITypes.ListAssistantDailyLogsQuery
>;
export const assistantDailyLogsByAssistantIdAndDate = /* GraphQL */ `query AssistantDailyLogsByAssistantIdAndDate(
  $assistantId: ID!
  $date: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAssistantDailyLogFilterInput
  $limit: Int
  $nextToken: String
) {
  assistantDailyLogsByAssistantIdAndDate(
    assistantId: $assistantId
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      assistantId
      assistant {
        id
        assistant_report
        assessment
        files_keys
        ocean
        location
        rank
        last_connection
        conditions_accepted
        createdAt
        updatedAt
        owner
        __typename
      }
      date
      mood
      tip_shown
      tip
      notes
      diagnostic
      rank
      created_at
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssistantDailyLogsByAssistantIdAndDateQueryVariables,
  APITypes.AssistantDailyLogsByAssistantIdAndDateQuery
>;
